@import '../../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../../constants/spacing.module.less';

.table {
  border: 1px solid var(--grey-300);
  background-color: var(--white);
}

.add-row-button {
  padding: @space-8 @space-16;

  svg {
    width: 12px;
    margin-right: @space-4;
  }
}

.select-product-dropdown {
  width: 100%;
}

.delete-button {
  > svg {
    color: var(--gray-818F9C);
    width: 14px;
  }
  &:hover {
    > svg {
      color: var(--gray-212c36);
    }
  }
}

.actions-cell {
  justify-content: center;
}

.box-header-row {
  border-bottom: unset;
}

.box-product-row {
  border-bottom: unset;
}

.negative-quantity-remaining {
  color: var(--red-FF4422);
}

.product-option {
  padding: @space-4 @space-0;
}
